const DEMIO = process.env.REACT_APP_DEMIO ?? ''
const demioUrl = DEMIO.endsWith('/') ? DEMIO.slice(0, -1) : DEMIO

const ROUTES = {
  BOOST: '/boost',
  TEAM: '/team',
  SETTINGS: '/settings',
  EVENTSYNC: '/demio-event-sync',
  LOGOUT: '/logout',
  SHARE: '/share',
  DEMIO: demioUrl,
}

export default ROUTES
